import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Radio } from 'redpoints-front-components/index';
import { withContext } from 'redpoints-front-common/components';

import { shortenerResolutionSetFiltersSelected } from '../../../actions/shortenerResolutionActions';
import { getShortenerResolutionFiltersSelected } from '../../../reducers/tasks/shortenerResolution';
import { translate } from '../../../helpers/languageHelper';

const ShortenerResolutionFilterByCustomer = ({
  customer: {
    name: customerName,
    tenant: { name: tenantName },
  },
  filtersSelected,
  isEnableFilterByTenant,
  shortenerResolutionSetFiltersSelected,
}) => {
  const { filterByCustomer } = filtersSelected;

  const handleChangeFilterByCustomer = ({ target: { value } }) => {
    shortenerResolutionSetFiltersSelected({
      ...filtersSelected,
      filterByCustomer: value,
    });
  };

  const filterByCustomerLabel = `${translate(
    'tasks.shortenerResolution.customerFilterSelector.filterByCustomerLabel'
  )} (${customerName})`;
  const filterByAllCustomersLabel = `${translate(
    'tasks.shortenerResolution.customerFilterSelector.filterByAllCustomersLabel'
  )} (${tenantName})`;

  return (
    <Radio
      className="rp-shortener-resolution-domains-filter-customer"
      data={[
        {
          value: true,
          text: filterByCustomerLabel,
        },
        {
          disabled: !isEnableFilterByTenant,
          value: false,
          text: filterByAllCustomersLabel,
        },
      ]}
      label={translate(
        'tasks.shortenerResolution.customerFilterSelector.label'
      )}
      value={filterByCustomer}
      onChange={handleChangeFilterByCustomer}
      vertical
    />
  );
};

const mapStateToProps = state => ({
  filtersSelected: getShortenerResolutionFiltersSelected(state),
});

export default compose(
  withContext,
  connect(mapStateToProps, {
    shortenerResolutionSetFiltersSelected,
  })
)(ShortenerResolutionFilterByCustomer);
